import { IntlShape } from 'react-intl';
import { Link } from '@lifeomic/chroma-react/components/Link';
import { pwtSharedMessages } from '@lifeomic/phc-web-toolkit/src/common/intlLabels';
import * as React from 'react';
import urls from '../../../src/util/urls';

export const buildGnomadUrlFromVariant = ({
  // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  variant,
  // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  displayValue,
  // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  referenceSetId,
}) => {
  const { alternate, chromosome, position, reference } = variant;

  if (!alternate || !chromosome || !position || !reference) {
    return null;
  }

  const formattedChromosome = chromosome.replace('chr', '');
  const url = urls.broadInstitute.variant(
    formattedChromosome,
    position,
    reference,
    alternate,
  );

  if (url && referenceSetId === 'GRCh37') {
    return (
      <Link to={url} onClick={e => e.stopPropagation()} newTab>
        {displayValue}
      </Link>
    );
  }

  return displayValue;
};

export const sangerUrlFromVariant = (value: any) => {
  const { cosmicId } = value.cosmic;

  if (!cosmicId) {
    return null;
  }

  /*
    Coding variants links won't have a page if they don't have an aminoAcidChange.
    Non-Coding links won't have aminoAcidChange, but should always render a (possibly broken) link
  */
  const isCodingVariant = cosmicId.includes('COSM');
  const isNonCodingVariant = cosmicId.includes('COSN');
  const hasAminoAcidChange = Boolean(value?.ensemblCanon?.[0]?.aminoAcidChange);

  if (isCodingVariant && hasAminoAcidChange) {
    const strippedId = cosmicId.replace('COSM', '');
    return urls.sanger.cosmicMutation(strippedId);
  }

  if (isNonCodingVariant) {
    const strippedId = cosmicId.replace('COSN', '');
    return urls.sanger.cosmicNcv(strippedId);
  }

  return null;
};

export const valueOrEmpty = (
  formatMessage: IntlShape['formatMessage'],
  value?: string,
) => {
  return value || formatMessage(pwtSharedMessages.emptyHash);
};
